import { render, staticRenderFns } from "./u-chip-outlined-pill.vue?vue&type=template&id=2c9b1182&scoped=true&"
import script from "./u-chip-outlined-pill.vue?vue&type=script&lang=js&"
export * from "./u-chip-outlined-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b1182",
  null
  
)

export default component.exports